import {
  AdministratorViewModel,
  PayrollReportHistoryRowStatusEnum,
  PayrollReportHistoryRowViewModel,
  ReportingPeriodViewModel,
} from '@fora-monorepo/employer-my-pages-common/types';

export const mockReportHistory: PayrollReportHistoryRowViewModel[] = [
  {
    payrollReportId: '617B885720731EDF8FBD6EA945DC4BF6',
    status: PayrollReportHistoryRowStatusEnum.Approved,
    hasEmploymentData: false,
    hasEmploymentDeviations: false,
    hasEmploymentInformation: false,
    source: 'FORA',
    createdDate: '2024-07-09T14:04:56',
    successfullyProcessedDate: '2024-07-09T12:09:11',
    payMonths: [
      {
        payMonth: '202404',
        hasDeviations: false,
        hasInformation: true,
      },
    ],
    adminReporterFullName: 'Sara Svensson',
    numberOfFiles: 2,
    organizationNumber: '55123454234',
    partnerNumberOrganization: '0030000356',
    employerName: 'HÄLLS MÅLERI AB',
  },
  {
    payrollReportId: '617B885720731EDF8FBD6EA945DC4BF6',
    status: PayrollReportHistoryRowStatusEnum.HasDeviations,
    hasEmploymentData: false,
    hasEmploymentDeviations: false,
    source: 'FORA',
    createdDate: '2024-07-09T14:04:56',
    successfullyProcessedDate: '2024-07-09T12:09:11',
    payMonths: [
      {
        payMonth: '202404',
        hasDeviations: true,
        hasInformation: false,
      },
    ],
    adminReporterFullName: 'Klara Karlsson',
    numberOfFiles: 2,
    organizationNumber: '55123454234',
    partnerNumberOrganization: '0030000356',
    employerName: 'HÄLLS MÅLERI AB',
    hasEmploymentInformation: true,
  },
  {
    payrollReportId: '617B885720731EDF8FBD6EA945DC4BF6',
    status: PayrollReportHistoryRowStatusEnum.Processing,
    hasEmploymentData: false,
    hasEmploymentDeviations: false,
    source: 'Visma',
    createdDate: '2024-07-09T14:04:56',
    successfullyProcessedDate: '2024-07-09T12:09:11',
    payMonths: [
      {
        payMonth: '202403',
        hasDeviations: false,
        hasInformation: false,
      },
    ],
    adminReporterFullName: 'Klara Karlsson',
    numberOfFiles: 2,
    organizationNumber: '55123454234',
    partnerNumberOrganization: '0030000356',
    employerName: 'HÄLLS MÅLERI AB',
    hasEmploymentInformation: false,
  },
];

export const mockPeriodForReportHistory: ReportingPeriodViewModel[] = [
  {
    isPeriodDue: true,
    isPeriodOpen: false,
    payMonth: '202407',
    periodFromDate: '2024-07-01',
    periodDueDate: '2024-08-31',
    periodToDate: '2024-08-31',
  },
  {
    isPeriodDue: true,
    isPeriodOpen: false,
    payMonth: '202406',
    periodFromDate: '2024-06-01',
    periodDueDate: '2024-07-31',
    periodToDate: '2024-07-31',
  },

  {
    payMonth: '202401',
    periodFromDate: '2024-01-01',
    periodToDate: '2024-03-31',
    periodDueDate: '2024-03-31',
    isPeriodDue: true,
    isPeriodOpen: false,
  },

  {
    payMonth: '202308',
    periodFromDate: '2023-08-01',
    periodToDate: '2023-09-30',
    periodDueDate: '2023-09-30',
    isPeriodDue: true,
    isPeriodOpen: false,
  },

  {
    payMonth: '202312',
    periodFromDate: '2023-12-01',
    periodToDate: '2024-01-31',
    periodDueDate: '2024-01-31',
    isPeriodDue: true,
    isPeriodOpen: false,
  },
];

export const mockAdministrators: AdministratorViewModel[] = [
  {
    firstName: 'Sara',
    lastName: 'Svensson',
    partnerNumberIndividual: '1234567',
  },
  {
    firstName: 'Klara',
    lastName: 'Karlsson',
    partnerNumberIndividual: '654321',
  },
];
